export * from './clientPayroll.component';



// WEBPACK FOOTER //
// ./src/app/ClientPayroll/index.ts